module.exports = __webpack_public_path__ + "static/media/avgTestScore.9a5e6118.svg";